/**
 * Logger utility that only logs in non-production environments
 */
class Logger {
  constructor() {
    this.isProduction = import.meta.env.VITE_ENV === "production";
    this.isDevelopment = import.meta.env.VITE_ENV === "development";
    this.isStaging = import.meta.env.VITE_ENV === "staging";
  }

  log(...args) {
    if (!this.isProduction) {
      console.log(...args);
    }
  }

  error(...args) {
    console.error(...args);
  }

  warn(...args) {
    console.warn(...args);
  }

  apiCall(method, url, data = null) {
    if (!this.isProduction) {
      console.log(`Call a la API!: ${method} ${url}`);
      if (data) {
        console.log("Data:", data);
      }
    }
  }

  apiResponse(data, endpoint = "") {
    if (!this.isProduction) {
      console.log(`Response API!: ${endpoint ? ` (${endpoint})` : ""}:`, data);
    }
  }

  auth(message, data = null) {
    if (!this.isProduction) {
      console.log("Auth", data);
    }
  }

  env() {
    if (!this.isProduction) {
      console.log("🔧 Environment:", {
        env: import.meta.env.VITE_ENV,
        apiUrl: import.meta.env.VITE_API_BASE_URL,
        version: import.meta.env.VITE_VERSION,
      });
    }
  }

  /**
   * Log component lifecycle events
   */
  component(componentName, event, data = null) {
    if (!this.isProduction) {
      console.log(`🧩 ${componentName}: ${event}`, data || "");
    }
  }

  /**
   * Log store/state changes
   */
  store(action, data = null) {
    if (!this.isProduction) {
      console.log(`📦 Store: ${action}`, data || "");
    }
  }
}

export default new Logger();
